import { useLDClient } from 'launchdarkly-react-client-sdk'
import { useEffect } from 'react'

import { useAuth } from '../components/AuthContext'

import { buildLDContext } from './context'

/**
 * Re-identifies the LaunchDarkly context once the store/user resolve, so flag
 * evaluation is keyed by store (for gradual rollout). Renders nothing and is a
 * no-op when LaunchDarkly is disabled (no client in context).
 */
export function LDIdentify(): null {
    const ldClient = useLDClient()
    const { platform, user } = useAuth()

    useEffect(() => {
        if (!ldClient) {
            return
        }
        const context = buildLDContext(platform, user)
        if (!context) {
            return
        }
        ldClient.identify(context).catch(() => {
            // identify failures shouldn't break the app
        })
    }, [ldClient, platform, user])

    return null
}
